module.exports = __webpack_public_path__ + "e8779344e2d9be002922c3e8ac9880da.pdf";